export type MileageRateSheetUpload = {
  rateSheet: File;
  transportBaseAddress: string;
  transportBaseLocation: { lat: number; lon: number };
  rateCurrency: string;
  baseCharge?: number;
  fuelSurchargePercentage?: number;
  maximumLoadKg?: number;
  willCollectFromAnywhere?: boolean;
};

export const buildMileageRateSheetFormData = ({
  rateSheet,
  transportBaseAddress,
  transportBaseLocation,
  rateCurrency,
  baseCharge,
  fuelSurchargePercentage,
  maximumLoadKg,
  willCollectFromAnywhere,
}: MileageRateSheetUpload) => {
  const formData = new FormData();
  formData.append('Rates', rateSheet);
  formData.append('TransportBaseAddress', transportBaseAddress);
  formData.append(
    'TransportBaseAddressLat',
    transportBaseLocation.lat.toString()
  );
  formData.append(
    'TransportBaseAddressLon',
    transportBaseLocation.lon.toString()
  );
  formData.append('RateCurrency', rateCurrency);
  formData.append('BaseCharge', String(baseCharge ?? 0));
  formData.append(
    'FuelSurchargePercentage',
    String(fuelSurchargePercentage ?? 0)
  );
  formData.append('MaximumLoadKg', String(maximumLoadKg));
  formData.append(
    'WillCollectFromAnywhere',
    String(willCollectFromAnywhere ?? false)
  );
  return formData;
};
